<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-10-20 15:54:47
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-10-27 10:54:00
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\Organization\departmentHomePage\departmentHomePage.vue
-->
<!-- 科室主页 -->
<template>
  <el-container class='all'>
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom='0px' :searchList='searchList' ref='expSearch' v-on:getSearchObj='getSearchObj'
        :rightEventList="rightEventList" @rightFunc='rightFunc'></publicExpandSearch>
    </div>
    <el-main class="list-box">
      <div class="department-list" v-loading="loading">
        <el-table id="tableInfo" :data="tableData" style="width: 100%">
          <el-table-column type='index' label="序号" align="center"></el-table-column>
          <el-table-column prop="openDepartmentName" label="线下科室" align="center"></el-table-column>
          <el-table-column prop="hospitalName" label="所属机构" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="setUp(scope.row)">编辑
              </el-button>
              <el-button type="text" size="small" @click="changeStatus(scope.row,scope.$index)">
                {{ scope.row.disabled == 1 ? '启用' : '禁用' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align:right;margin-right:30px;margin-top:30px" background
          @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="searchParams.current" :page-size="searchParams.size"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { departmentList, departUpdateStatus } from "./api/index";
export default {
  data() {
    return {
      breadList: [{ name: "机构组织" }, { name: "科室主页" }],
      rightEventList: [{ eventName: "新增", eventValue: 1 }],
      searchList: [
        {
          label: "关键字",
          paramName: "keyword",
          inputType: "input"
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      tableData: [],
      total: 0,
      loading: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getData();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.setUp();
      }
    },
    //列表数据
    getData() {
      this.loading = true;
      departmentList(this.searchParams).then(res => {
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.records;
        }
        this.loading = false;
      });
    },
    //启用禁用
    changeStatus(row, index) {
      this.loading = true;
      console.log(index);
      departUpdateStatus(row.id).then(res => {
        if (res.code == 0) {
          this.tableData[index].disabled = !this.tableData[index].disabled;
          this.$message({
            message: "成功",
            type: "success"
          });
        }
        this.loading = false;
      });
    },
    //编辑
    setUp(row) {
      this.$router.push({
        path: "/Organization/departmentHomePage/configDepartmentPage",
        query: {
          id: row ? row.id : null,
          isEdit: row ? true : false
        }
      });
    },
    //触发分页
    handleSizeChange(e) {
      this.searchParams.size = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.searchParams.current = e;
      this.getData();
    }
  },
  //⽣命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //⽣命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getData();
  }
};
</script>
<style scoped lang="less">
/* @import url(); 引⼊公共css类 */
.all {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .list-box {
    margin: 0 16px;
    padding: 0;
    .department-list {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      padding: 16px;
    }
  }
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}

/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}

/deep/.el-table th {
  background: #fafafa;
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>